import { render } from "./RoomsDetails.vue?vue&type=template&id=3c1d3ab8"
import script from "./RoomsDetails.vue?vue&type=script&lang=js"
export * from "./RoomsDetails.vue?vue&type=script&lang=js"

import "./RoomsDetails.vue?vue&type=style&index=0&id=3c1d3ab8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__